import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-feedback",
  "use": "icon-feedback-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-feedback\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 2C2.44772 2 2 2.44772 2 3V16C2 16.5523 2.44772 17 3 17H7V20.7929C7 21.2383 7.53857 21.4614 7.85355 21.1464L12 17H21C21.5523 17 22 16.5523 22 16V3C22 2.44772 21.5523 2 21 2H3Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol